import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Header from '../../UFOHeader';

function UFOTemplate(props) {
    const {
        children,
        referrer,
        history
    } = props;
    const classes = cn(
        'ulx-antialias',
        'ulx-aem-content-container',
        'ulx-aem-vr',
        'ufo-template'
    );
    return (
        <div className={classes}>
            <Header referrer={referrer} history={history} />
            <section className={cn('ufo-template__content')}>
                <div className={cn('ufo-template__content-inner')}>
                    {children}
                </div>
            </section>
        </div>
    );
}

UFOTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired
    }).isRequired,
    referrer: PropTypes.string.isRequired
};

export default UFOTemplate;
